import React from 'react';
import { Link } from 'react-router-dom';

export interface FlowPageBreadcrumbItem {
  label: string;
  path?: string;
}

interface FlowPageLayoutProps {
  title: string;
  breadcrumbItems: FlowPageBreadcrumbItem[];
  children: React.ReactNode;
  /** Optional content between title and children (e.g. StepIndicator) */
  headerExtra?: React.ReactNode;
}

/**
 * Shared layout for flow-style pages (e.g. Add Client, Questionnaire - Final).
 * Renders breadcrumb, title, and children. Use inside MainContent.
 */
export const FlowPageLayout: React.FC<FlowPageLayoutProps> = ({
  title,
  breadcrumbItems,
  children,
  headerExtra,
}) => {
  return (
    <>
      <div className="px-0 pt-0 pb-4">
        <nav
          aria-label="Breadcrumb"
          className="flex flex-wrap items-center rounded-xl border border-border bg-background px-5 py-3 text-sm text-muted-foreground"
        >
          {breadcrumbItems.map((item, index) => (
            <React.Fragment key={index}>
              {index > 0 && <span className="mx-2 text-muted-foreground/60">/</span>}
              {item.path != null ? (
                <Link to={item.path} className="hover:text-foreground transition-colors">
                  {item.label}
                </Link>
              ) : (
                <span className="font-medium text-foreground">{item.label}</span>
              )}
            </React.Fragment>
          ))}
        </nav>
      </div>

      <div className="space-y-6 px-0 pb-8 pt-5">
        <h2 className="text-[40px] font-semibold tracking-tight text-foreground">{title}</h2>
        {headerExtra}
        {children}
      </div>
    </>
  );
};
